export function addAttributes(sessions) {
  let groups = [];
  for (let i = 0; i < sessions.length; i++) {
    if (sessions[i].type === null) sessions[i].type = { value: { color: '#000000', background: '#ffffff' }};
    if (sessions[i].overlappings.length) {
      const group = groups.findIndex(group => 
        group.day_id === sessions[i].day_id 
        && group.room_id === sessions[i].room_id 
        && !(sessions[i].end_time_timestamp <= group.start_time_timestamp || sessions[i].start_time_timestamp >= group.end_time_timestamp)
      );
      if (group >= 0) {
        if (groups[group].start_time_timestamp > sessions[i].start_time_timestamp) groups[group].start_time_timestamp = sessions[i].start_time_timestamp;
        if (groups[group].end_time_timestamp > sessions[i].end_time_timestamp) groups[group].end_time_timestamp = sessions[i].end_time_timestamp;
        groups[group].sessions.push(sessions[i].id);
      } else {
        groups.push({ 
          day_id: sessions[i].day_id, 
          room_id: sessions[i].room_id, 
          start_time_timestamp: sessions[i].start_time_timestamp, 
          end_time_timestamp: sessions[i].end_time_timestamp, 
          sessions: [sessions[i].id], 
        });
      }
    }
  }
  for (let i = 0; i < sessions.length; i++) {
    const group = groups.findIndex(group => group.sessions.includes(sessions[i].id));
    sessions[i].overlaps = (group >= 0) ? groups[group].sessions.length : 1;
  }
  return sessions;
}
